/**
 * Onboarding Events
 */
enum Events {
  AnalyticEvent = 'analytic-event',
  ApplicationSubmit = 'applicationSubmit',
  Close = 'close',
  Complete = 'complete',
  Loaded = 'loaded',
  Mount = 'mount',
  PageChange = 'page-change',
  QuestionFocus = 'questionFocus',
  Show = 'show',
}

export default Events;
